import DottedSeparator from './DottedSeparator';

export default DottedSeparator;
